var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCancel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 8,
    fill: "#B3B3B3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.29169 9.99984L6.81317 7.52132C6.61762 7.32577 6.61762 7.00872 6.81317 6.81317C7.00872 6.61762 7.32577 6.61762 7.52132 6.81317L9.99984 9.29169L12.4784 6.81317C12.6739 6.61762 12.991 6.61762 13.1865 6.81317C13.3821 7.00872 13.3821 7.32577 13.1865 7.52132L10.708 9.99984L13.1865 12.4784C13.3821 12.6739 13.3821 12.991 13.1865 13.1865C12.991 13.3821 12.6739 13.3821 12.4784 13.1865L9.99984 10.708L7.52132 13.1865C7.32577 13.3821 7.00872 13.3821 6.81317 13.1865C6.61762 12.991 6.61762 12.6739 6.81317 12.4784L9.29169 9.99984Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancel);
export default __webpack_public_path__ + "static/media/Cancel.4a65cb3b.svg";
export { ForwardRef as ReactComponent };